import { render, staticRenderFns } from "./B2B_CABECALHO.vue?vue&type=template&id=50432d7e"
import script from "./B2B_CABECALHO.vue?vue&type=script&lang=js"
export * from "./B2B_CABECALHO.vue?vue&type=script&lang=js"
import style0 from "./B2B_CABECALHO.vue?vue&type=style&index=0&id=50432d7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports